// eslint-disable-next-line import/prefer-default-export
export const limitOptions = [
    {
        label: '12 Items',
        value: 12
    },
    {
        label: '20 Items',
        value: 20
    },
    {
        label: '40 Items',
        value: 40
    }
];
